// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import VueI18n from 'vue-i18n';
import AsyncComputed from 'vue-async-computed';
import VueResource from 'vue-resource';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.use(VueMatomo, {
  host: 'https://nsa.parnswir.de',
  siteId: 1,
  // Enables automatically registering pageviews on the router
  router,
  // Require consent before sending tracking information to matomo
  requireConsent: false,
});

Vue.use(VueI18n);
const userLocale = localStorage.locale ? localStorage.locale : 'en';

const i18n = new VueI18n({
  locale: userLocale,
  fallbackLocale: 'en',
});

Vue.use(AsyncComputed);
Vue.use(VueResource);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js